export interface PagedData<T> {
	data: T[];
	pageCount: number;
	pageNumber: number;
	totalItems: number;
}

export function isPagedData<T> (data: any): data is PagedData<T> {
	return data &&
			Array.isArray(data.data) &&
			typeof data.pageCount === "number" &&
			typeof data.pageNumber === "number" &&
			typeof data.totalItems === "number"
}
